import { Component } from '@angular/core';
import { Data, DataLoaderService, CommonDataService, Subscription } from '../service-call-index';
@Component({
  selector: 'package-details',
  templateUrl: './package-details.template.html',
  styleUrls: ['./package-details.component.css'],
})
export class PackageDetailsComponent {
  public package = [];
  public equipmentList: Data[];
  private subscription: Subscription;
  public selectedIndex: string = "item";
  public currency: string;
  public icon = "gray";
  constructor(private dataLoaderService: DataLoaderService, private commonDataService: CommonDataService) {
    
  }

  ngOnInit() {
    this.subscription = this.commonDataService.notifyObservablePackage$.subscribe((res) => {
      this.package = [];
      this.package.push(res.item);
      if (res.item.packagedEquipmentList != undefined)
        this.equipmentList = res.item.packagedEquipmentList;
      else
        this.equipmentList = res.item.localPackagedEquipmentList;
      this.currency = this.dataLoaderService.data.currencyType;
    });
  }

  /**
   * To select a particular package option
   * @param index
   * @returns none
   */
  selectItem(index) {
    this.selectedIndex = index;
  }

}


// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/normal-screen-components/package-details/package-details.component.ts